$(() => {
  const copyToClipboards = $('.copy-to-clipboard');

  const onCopyToClipboard = ($event) => {
    const element = $($event.currentTarget);
    const copyText = element.attr('data-copy-text');
    const copiedText = element.attr('data-copied-text');
    const copyFailedText = element.attr('data-copy-failed-text');
    const copyValue = element.attr('data-value');

    navigator.clipboard.writeText(copyValue).then(
      () => {
        element.attr('data-current-state', copiedText);
        setTimeout(() => {
          element.attr('data-current-state', copyText);
        }, 2000);
      },
      () => {
        element.attr('data-current-state', copyFailedText);
      }
    );
  };

  copyToClipboards.on('click', onCopyToClipboard);
});
